import { AuthProfileType, LoginTypes } from '../enums';
export var getLoginType = function(profile) {
    switch(profile){
        case AuthProfileType.Recruiter:
            return LoginTypes.Employer;
        case AuthProfileType.Contractor:
            return LoginTypes.Contractor;
        case AuthProfileType.ClientService:
            return LoginTypes.Customer;
        case AuthProfileType.AppSupport:
            return LoginTypes.Support;
        case AuthProfileType.GorillaResumeUser:
            return LoginTypes.GorillaResume;
        default:
            return LoginTypes.Client;
    }
};
